import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IHowitworks, IHowitworksInitialState } from "./HowitworksModel";
import {
  ActiveInactiveHowitworks,
  createHowitworks,
  deleteHowitworks,
  getAllActiveHowitworks,
  getAllHowitworks,
  getHowitworksByID,
  HowitworksImageUpload,
  updateHowitworks,
} from "./services/howitworks.services";

const initialState: IHowitworksInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  HowitworksID: null,
  HowitworksList: [],
  HowitworksDetail: {
    ID: null,
    Title: "",
    ShortDescription: "",
    SequenceNo: null,
    Type: "Home",
    IconImage: "",
    MainImage: "",
    IsActive: 1,
  },
};

const howitworksSlice = createSlice({
  name: "howitworks",
  initialState,
  reducers: {
    clearHowitworksDetails: (state) => {
      state.HowitworksDetail = initialState.HowitworksDetail;
    },
    setHowitworksID: (state, action) => {
      state.HowitworksID = action.payload;
    },
    clearHowitworksID: (state) => {
      state.HowitworksID = initialState.HowitworksID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllHowitworks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllHowitworks.fulfilled,
      (state, action: PayloadAction<IHowitworks[]>) => {
        state.loading = false;
        state.HowitworksList = action.payload || [];
      },
    );
    builder.addCase(getAllHowitworks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HowitworksList = [];
    });
    builder.addCase(createHowitworks.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createHowitworks.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createHowitworks.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateHowitworks.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateHowitworks.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateHowitworks.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteHowitworks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteHowitworks.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteHowitworks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getHowitworksByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getHowitworksByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.HowitworksDetail = action.payload;
    });
    builder.addCase(getHowitworksByID.rejected, (state, action) => {
      state.formLoading = false;
      state.HowitworksDetail = initialState.HowitworksDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveHowitworks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveHowitworks.fulfilled,
      (state, action: PayloadAction<IHowitworks[]>) => {
        state.loading = false;
        state.HowitworksList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveHowitworks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HowitworksList = [];
    });
    builder.addCase(ActiveInactiveHowitworks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveHowitworks.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveHowitworks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(HowitworksImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(HowitworksImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(HowitworksImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearHowitworksDetails, clearHowitworksID, setHowitworksID } =
  howitworksSlice.actions;
export default howitworksSlice.reducer;
